import React from "react";
import IconContainer from "@/components/ui/icon-container";
import Text from "@/components/ui/text";

interface Props {
  title: string;
  content: JSX.Element;
  icon?: JSX.Element;
}

const ExpandedViewDetail: React.FC<Props> = ({ title, content, icon }) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        {icon && (
          <IconContainer
            size="sm"
            color="secondary"
            className="[&>svg]:size-full"
          >
            {icon}
          </IconContainer>
        )}
        <Text variant="bodySecondary">{title}</Text>
      </div>
      {content}
    </div>
  );
};

export default ExpandedViewDetail;
